import {DialogFooter, FormButton, FormControl, openConfirmDialog} from 'platform/components';
import {HStack} from 'platform/foundation';

import {UseFormReturn, useWatch} from 'react-hook-form';

import i18n from '@dms/i18n';

import {pushGtmEvent, useDebouncedValue} from 'shared/web';

import {DelayEnum} from '../constants/DelayEnum';
import {DeliveryNoteDocumentPreviewFormDefinition} from '../types/DeliveryNoteDocumentPreviewFormDefinition';

interface FooterProps {
  isConfirmed: boolean;
  control: FormControl<DeliveryNoteDocumentPreviewFormDefinition>;
  formApi: UseFormReturn<DeliveryNoteDocumentPreviewFormDefinition>;
  onDiscard: VoidFunction;
  onClose: VoidFunction;
}

export function Footer(props: FooterProps) {
  const listOfItems = useWatch({control: props.control, name: 'listOfItems'});

  const debouncedListOfItems = useDebouncedValue(listOfItems, DelayEnum.FOOTER);

  const hasActiveItems = debouncedListOfItems.some((item) => item.isActive);

  return (
    <DialogFooter>
      <HStack justify="space-between">
        <FormButton
          control={props.control}
          type="button"
          title={i18n.t('entity.documentExtraction.actions.discardChanges')}
          variant="dangerLink"
          onClick={() => {
            pushGtmEvent({event: 'button_click', event_id: 'ai_tool_dn_discard_changes'});
            openConfirmDialog({
              text: i18n.t('entity.documentExtraction.labels.discardChangesConfirmation'),
              onConfirm: () => {
                pushGtmEvent({
                  event: 'button_click',
                  event_id: 'ai_tool_dn_discard_changes_confirm',
                });
                props.onDiscard();
              },
            });
          }}
        />
        <HStack spacing={2}>
          <FormButton
            control={props.control}
            type="button"
            variant="secondary"
            title={i18n.t('entity.documentExtraction.actions.leave')}
            onClick={() => {
              pushGtmEvent({event: 'button_click', event_id: 'ai_tool_dn_leave_delivery_note'});
              props.onClose();
            }}
          />
          <FormButton
            isDisabled={!props.isConfirmed || !hasActiveItems}
            control={props.control}
            type="submit"
            title={i18n.t('entity.documentExtraction.actions.create')}
            onClick={() => {
              pushGtmEvent({event: 'button_click', event_id: 'ai_tool_dn_create_delivery_note'});
            }}
          />
        </HStack>
      </HStack>
    </DialogFooter>
  );
}
